import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import { Form, Formik } from "formik";
import { useTranslation } from "next-i18next";
import { useRef } from "react";

import Input from "../../forms/Input";
import CloseIcon from "../../icons/CloseIcon";
import Loading from "@/components/global/Loading";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import BookInputHeader from "./BookInputHeader";
import BookInfo from "./BookInfo";
import { BookServiceValidation } from "@/utils/valitation/book-service";
import { useRouter } from "next/router";

const BookServiceModal = ({ Context }) => {
  const ref = useRef();
  useOnClickOutside([ref], () => Context?.dispatch({ type: "bookService" }));
  const { t } = useTranslation("common");
  const onSubmit = () => null;
  useBodyScrollLock();
  const { locale } = useRouter();

  const event = Context?.state?.bookedEvent;

  return (
    <div
      ref={ref}
      className="w-11/12 sm:w-[640px] bg-white rounded-md max-h-[85vh] overflow-y-auto p-3"
    >
      <div className="flex items-center justify-between pb-2 border-b mb-3">
        <h2 className="font-bold sm:text-xl">
          {t("Book a service appointment")}
        </h2>
        <CloseIcon
          onClick={() => Context?.dispatch({ type: "bookService" })}
          className="cursor-pointer text-secondary-800 size-3 sm:size-4"
        />
      </div>

      <Formik
        onSubmit={onSubmit}
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          company: "",
        }}
        validationSchema={BookServiceValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form>
            <BookInputHeader title={t("Scheduled Times")} />
            <div className="grid sm:grid-cols-2">
              <BookInfo
                label={t("Start Time")}
                value={new Date(event?.start).toLocaleDateString(
                  locale === "en" ? "en-US" : "ar-EG",
                  {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                  }
                )}
              />
              <BookInfo
                label={t("End Time")}
                value={new Date(event?.end).toLocaleDateString(
                  locale === "en" ? "en-US" : "ar-EG",
                  {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                  }
                )}
              />
            </div>
            <BookInputHeader title={t("General Information")} />

            <div className="grid sm:grid-cols-2 mb-3 gap-3">
              <Input
                name="what_equipment"
                id="what_equipment"
                label={t("What equipment do you own?")}
                labelClassName="mb-2 font-semibold text-sm"
                component="textarea"
                row={4}
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />

              <Input
                name="details"
                id="details"
                label={t("Details about your appointment")}
                labelClassName="mb-2 font-semibold text-sm"
                component="textarea"
                row={4}
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
            </div>

            <BookInputHeader title={t("Personal Details")} />

            <div className="grid sm:grid-cols-2 mb-3 gap-3">
              <Input
                name="first_name"
                id="first_name"
                label={t("First Name")}
                labelClassName="mb-2 font-semibold text-sm"
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
              <Input
                name="last_name"
                id="last_name"
                label={t("Last Name")}
                labelClassName="mb-2 font-semibold text-sm"
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
              <Input
                name="email"
                id="email"
                label={t("Email")}
                labelClassName="mb-2 font-semibold text-sm"
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
              <Input
                name="phone_number"
                id="phone_number"
                label={t("Phone")}
                labelClassName="mb-2 font-semibold text-sm"
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
              <Input
                name="company"
                id="company"
                label={t("Company")}
                labelClassName="mb-2 font-semibold text-sm"
                inputClassName="border max-sm:placeholder:text-xs max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
            </div>

            <div className="flex items-center gap-6">
              <button
                className="bg-primary text-white max-sm:text-sm py-2 px-12  rounded-md font-semibold"
                type="submit"
              >
                {isSubmitting ? <Loading /> : t("Submit")}
              </button>
              <button
                onClick={() => Context?.dispatch({ type: "bookService" })}
                className="underline max-sm:text-sm   font-semibold"
                type="submit"
              >
                {t("Cancel")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BookServiceModal;
